import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  StatisticsTableSearchProps,
  StatisticsTableSortProps
} from './statistics-table-base.types'

export const initialStatisticsTablePaginationProps: PaginationProps<StatisticsTableSortProps> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: StatisticsTableSortProps.PRODUCT_NAME,
  totalElements: 0,
  totalPages: 0
}

export const initialStatisticsTableSearchProps: StatisticsTableSearchProps = {
  id: null,
  productName: '',
  storeName: '',
  activeSkusMin: null,
  activeSkusMax: null,
  stockMin: null,
  stockMax: null,
  soldMin: null,
  soldMax: null,
  minRevenue: null,
  maxRevenue: null,
  addedOnPeriod: null
}

export const statisticsNeedTimeoutProps: Array<keyof StatisticsTableSearchProps> = [
  'productName'
]
